export default __webpack_public_path__ + "static/media/scanning-document.6039ffae.svg";